import axios from 'axios';
import { setOnScreenEls, checkOnScreenEls } from '../common/on-screen';

import '../../sass/blocks/portfolio.scss';

(() => {
    const $portfolios = document.querySelectorAll('.portfolio');

    if (!$portfolios) return;

    $portfolios.forEach($portfolio => {
        const $portfolioResults = $portfolio.querySelectorAll('.portfolio-results');

        const filterAbortController = new AbortController();

        const $filter = $portfolio.querySelector('.portfolio-filter');
        const $filterNonce = $portfolio.querySelector('input[name="delancey_theme_filter_portfolio_wpnonce"]');
        const $filterInputs = $portfolio.querySelectorAll('.portfolio-filter input');
        const $filterSelects = $portfolio.querySelectorAll('.portfolio-filter select');
        const $filterSectorSelect = $portfolio.querySelector('.portfolio-filter__sector-select');
        const $filterSectorDot = $portfolio.querySelector('.portfolio-filter__sector-dot');

        const $noResults = $portfolio.querySelector('.portfolio-no-results');

        const $searchAssetType = $filter?.querySelector('select[name="asset_type"]');
        const $searchSector = $filter?.querySelector('select[name="sector"]');
        const $searchKeyword = $filter?.querySelector('input[name="keyword"]');
        const $searchPostsPerPage = $filter?.querySelector('input[name="posts_per_page"]');

        const changeSectorSelectDotColour = () => {
            if (!$filterSectorDot || !$filterSectorSelect) return;

            $filterSectorSelect.addEventListener('change', () => {
                const highlightColour = $filterSectorSelect?.options[$filterSectorSelect.selectedIndex]?.dataset?.highlightColour;

                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--green');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--blue');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--light-blue');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--gold');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--warm-grey');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--cool-grey');
                $filterSectorDot.classList.remove('portfolio-filter__sector-dot--pink');

                if (highlightColour) {
                    $filterSectorDot.classList.add(`portfolio-filter__sector-dot--${highlightColour}`);
                }
            });
        };

        const fieldHasBeenUpdated = $el => {
            const url = new URL(window.location.href);
            const searchParams = url.searchParams;
            const currValue = searchParams.get($el.name) ?? '';

            return $el.value !== currValue;
        };

        const submitFilter = (submitFallback = false) => {
            const asset_type = $searchAssetType?.value ?? null;
            const sector = $searchSector?.value ?? null;
            const keyword = $searchKeyword?.value ?? null;

            axios.get(GLOBALS.AJAX_URL, {
                signal: filterAbortController.signal,
                params: {
                    action: 'delancey_theme_filter_portfolio',
                    nonce: $filterNonce?.value ?? null,
                    sector: sector,
                    asset_type: asset_type,
                    keyword: keyword,
                    posts_per_page: -1,
                }
            }).then(response => {
                if (!$portfolioResults) return;

                let hasResults = false;
    
                $portfolioResults.forEach($portfolioResults => {
                    $portfolioResults?.classList.add('portfolio-results--loading');

                    const { assetType } = $portfolioResults?.dataset;
    
                    if (asset_type === assetType || asset_type === '') {
                        $portfolioResults.classList.add('portfolio-results--show');
                    } else {
                        $portfolioResults.classList.remove('portfolio-results--show');
    
                        return;
                    }
    
                    const $resultsListInner = $portfolioResults.querySelector('.portfolio-results__list-inner');
    
                    console.log(response?.data?.data?.html?.[assetType]);

                    // If results returned show results list and hide 'no results' message
                    if (response?.data?.data?.html?.[assetType]) {
                        $resultsListInner.innerHTML = response.data.data.html[assetType];
    
                        $portfolioResults.classList.add('portfolio-results--show');

                        hasResults = true;
                    }
    
                    // If no results returned show 'no results' message and hide results
                    if (!response?.data?.data?.html?.[assetType]) {
                        $portfolioResults.classList.remove('portfolio-results--show');
                    }
                });

                // Show no results message
                if (hasResults) {
                    $noResults.classList.remove('portfolio-no-results--show');
                } else {
                    $noResults.classList.add('portfolio-no-results--show');
                }
    
                setTimeout(() => {
                    setOnScreenEls();
                    checkOnScreenEls();
                }, 250);
    
                // Build new URL
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;
    
                // Add sector to URL
                if (sector) {
                    searchParams.set('sector', sector);
                } else {
                    searchParams.delete('sector');
                }
    
                // Add asset_type to URL
                if (asset_type) {
                    searchParams.set('asset_type', asset_type);
                } else {
                    searchParams.delete('asset_type');
                }
    
                // Add keyword to URL
                if (keyword) {
                    searchParams.set('keyword', keyword);
                } else {
                    searchParams.delete('keyword');
                }
    
                // Add block_anchor to URL
                if ($portfolio?.id) {
                    searchParams.set('block_anchor', $portfolio.id);
                } else {
                    searchParams.delete('block_anchor');
                }
    
                // Update URL
                window.history.replaceState('', '', url.toString());
    
                // Set back_url for portfolio links
                $portfolioResults.forEach($portfolioResults => {
                    const $portfolioCardLinks = $portfolioResults.querySelectorAll('.portfolio-card__link');
        
                    if ($portfolioCardLinks) {
                        $portfolioCardLinks.forEach($portfolioCardLink => {
                            if (!$portfolioCardLink?.href) return;
        
                            const cardUrl = new URL($portfolioCardLink.href);
                            const cardUrlSearchParams = cardUrl.searchParams;
        
                            cardUrlSearchParams.set('back_url', window.location.href);
        
                            $portfolioCardLink.href = cardUrl.toString();
                        });
                    }
                });
            }).catch(error => {
                console.log(error);

                if (submitFallback) {
                    $filter.submit();
                }
            }).finally(() => {
                $portfolioResults.forEach($portfolioResults => {
                    $portfolioResults?.classList.remove('portfolio-results--loading');
                });
            });
        };

        const initFilter = () => {
            if (!$filter) return;

            let filterTimeout = null;

            $filter.addEventListener('submit', e => {
                e.preventDefault();

                submitFilter(true);
            });

            $filterInputs.forEach($filterInput => {
                $filterInput.addEventListener('keyup', e => {
                    if (fieldHasBeenUpdated(e.target)) {
                        clearTimeout(filterTimeout);

                        filterTimeout = setTimeout(() => {
                            submitFilter();
                        }, 500);
                    }
                    
                    if (e.key === "Enter") {
                        clearTimeout(filterTimeout);
                    }
                });
            });

            $filterSelects.forEach($filterSelect => {
                $filterSelect.addEventListener('change', e => {
                    if (fieldHasBeenUpdated(e.target)) {
                        submitFilter();
                    }
                    
                    if (e.key === "Enter") {
                        clearTimeout(filterTimeout);
                    }
                });
            });
        };

        changeSectorSelectDotColour();
        initFilter();
    });
})();
